import z from "zod"

export const adicionarMembroSchema = z.object({
  name: z.string().min(1, "Nome completo é obrigatório"),
  pj_name: z.string().min(1, "Razão Social é obrigatória"),
  document: z
    .string()
    .min(14, "CPF deve ter 11 dígitos"),
  pj_document: z
    .string()
    .min(14, "CNPJ deve ter 14 dígitos"),
  email: z
    .string()
    .min(1, "Email é obrigatório")
    .email("Email deve ter um formato válido"),
  role: z
    .string()
    .min(1, "Cargo é obrigatório"),
})

export type AdicionarMembroFormData = z.infer<typeof adicionarMembroSchema>